<div class="main-content">
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="d-sm-flex align-items-center justify-content-between mb-4 margin-bottom">
                    <h1 class="h3 mb-0 text-gray-800">Email Templates</h1>
                    <div class="actionButtons">
                        <!--<a id="cShowFilter" (click)="toggleFilter()" class="d-none d-sm-inline-block btn btn-primary btn-sm  shadow-sm margin-right-5">
                            <i *ngIf="!enableFilter" class="fas fa-filter text-white-50"> <span class="button-text"> Search</span></i>
                            <i *ngIf="enableFilter" class="fas fa-filter text-white-50"> <span class="button-text"> Hide Search</span></i>
                        </a>-->
                        <a [routerLink]="['/app/newemailtemplate']" class="d-none d-sm-inline-block btn btn-sm btn-primary shadow-sm">
                            <i class="fas fa-plus text-white-50"> <span class="button-text">Create Template</span></i>
                        </a>
                    </div>
                    
                </div>

                <ng-container *ngIf="loading">
                    <div class="loading text-center">
                        <br />
                        <img style="padding-top:50px;" src="../../../assets/img/gif/loading.gif" alt="Alternate Text" />
                        <br />
                        <p>Loading assessments, please wait...</p>
                    </div>
                </ng-container>

                <!--<div class="card shadow" >-->
                    <div *ngIf="!loading" class="topSpacing">

                        <div>
                            <ul class="tab-nav">
                                <li (click)="tabSelected(1)" class="active"><a data-toggle="tab" href="#Tab1">ELI - Self Assessment</a></li>
                                <li (click)="tabSelected(2)"><a data-toggle="tab" href="#Tab2">ELI 360</a></li>
                            </ul>
                        </div>

                        <div class="main-tab-content tab-content">
                            <div id="Tab1" class="tab-pane fade in active">
                                <div id="containerGrid" style="width: 100%; max-height: 400px; height:400px;">
                                    <ag-grid-angular #agGrid
                                                     style="width: 100%; height: 100%;"
                                                     class="ag-theme-balham"
                                                     [enableFilter]="true"
                                                     [floatingFilter]="true"
                                                     [gridOptions]="gridOptions"
                                                     [rowData]="regularData"
                                                     [columnDefs]="dataHeaders"
                                                     [enableSorting]="true"
                                                     [enableColResize]="true"
                                                     (rowClicked)="onRowClicked($event)"
                                                     (gridReady)="onGridReady($event)"
                                                     [pagination]="true"
                                                     [paginationPageSize]="25"
                                                     [overlayNoRowsTemplate]="overlayNoRowsTemplate"
                                                     [rowSelection]="rowSelection"
                                                     (rowSelected)="onRowSelected($event)"
                                                     (selectionChanged)="onSelectionChanged($event)"
                                                     [rowMultiSelectWithClick]="true"
                                                     [suppressRowClickSelection]="true">
                                    </ag-grid-angular>
                                </div>
                            </div>

                            <div id="Tab2" class="tab-pane fade">
                                <div id="containerGrid" style="width: 100%; max-height: 400px; height:400px;">
                                    <ag-grid-angular #agGrid
                                                     style="width: 100%; height: 100%;"
                                                     class="ag-theme-balham"
                                                     [enableFilter]="true"
                                                     [floatingFilter]="true"
                                                     [gridOptions]="gridOptions"
                                                     [rowData]="data360"
                                                     [columnDefs]="dataHeaders"
                                                     [enableSorting]="true"
                                                     [enableColResize]="true"
                                                     (rowClicked)="onRowClicked($event)"
                                                     (gridReady)="onGridReady($event)"
                                                     [pagination]="true"
                                                     [paginationPageSize]="25"
                                                     [overlayNoRowsTemplate]="overlayNoRowsTemplate"
                                                     [rowSelection]="rowSelection"
                                                     (rowSelected)="onRowSelected($event)"
                                                     (selectionChanged)="onSelectionChanged($event)"
                                                     [rowMultiSelectWithClick]="true"
                                                     [suppressRowClickSelection]="true">
                                    </ag-grid-angular>
                                </div>
                            </div>
                        </div>

                    </div>
                <!--</div>-->
            </div>
        </div>
    </div>
</div>
